var ReservationCardConstants = {
  CHANGE_EVENT: 'changeEvent',
  INIT: 'init',
  REFRESH: "refresh",
  SAVE: 'save',
  SET_ACTIVE_TAB: 'setActiveTab',
  SET_SUBMIT_BUTTON: 'setSubmitButton',
  CHANGE_NOTES: 'changeNotes',
  UPDATE_NOTE_COUNT: 'updateNoteCount',
  UPDATE_SERVICE_REQUEST_COUNT: 'updateServiceRequestCount',
};
export default ReservationCardConstants;